import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Panel,
  Alert,
  Row,
  Col,
} from 'react-bootstrap';
import { copy } from 'utils';

class NotificationAdminOptions extends Component {
  static propTypes = {
    addGroup: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      new_group: {
        name: '',
        category: ''
      }
    }
  }
  handleChange(value, name) {
    const new_group = copy(this.state.new_group);

    new_group[name] = value;

    this.setState({
      new_group
    });
  }
  render() {
    return (
      <Panel
        bsStyle='danger'
        header={<h3>Admin Settings</h3>}
        footer={(
          <div className='clearfix'>
            <Button onClick={e => this.props.addGroup(this.state.new_group)} bsStyle='primary' className="pull-right">Create</Button>
          </div>
        )}
        >
        <label className='control-label'>Name</label>
        <input
          onChange={e => this.handleChange(e.target.value, 'name')}
          className='form-control mb-sm'
          type='text'
          placeholder='Enter a group name.'
          value={this.state.new_group.name}
        />
        <label className='control-label'>Category</label>
        <input
          onChange={e => this.handleChange(e.target.value, 'category')}
          className='form-control'
          type='text'
          placeholder='Enter a group category.'
          value={this.state.new_group.category}
        />
        <Alert
          bsStyle='info'
          className='mt-sm'
          >
          Enter a new notification group name and category.
        </Alert>
      </Panel>
    )
  }
}

export default NotificationAdminOptions;



// WEBPACK FOOTER //
// ./src/browser/components/settings/notifications/notification-admin-options.js